import { PHONE_MASK, INN_MASK, PHONE_PLACEHOLDER } from "@/consts";
import { useDataFormStore } from "@/stores/form";
import { limitInput } from "@/utils/handleChangeForm"
import { getNameOrganization } from "@/utils/getDataForm";
import { inject } from 'vue';


export default {
  props: {
    isCargoPickup: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const dataForm = useDataFormStore();

    const citiesArr = inject('citiesArr', []);
    
    const options = [
      {
        value: "Стандарт",
        label: "Стандарт",
      },
      {
        value: "Цилиндры",
        label: "Цилиндры",
      },
      {
        value: "Шины",
        label: "Шины",
      },
    ];

    const cityToRestrictions = inject('cityToRestrictions');
    

    function handlerCityTo(city) {
      if (props.isCargoPickup) {
        const selectedFullInfoCity = citiesArr.value.find(({ name }) => name === city);
        cityToRestrictions.value = {
          name: selectedFullInfoCity.name,
          maxAcceptedHeight: selectedFullInfoCity.maxAcceptedShippingHeight,
          maxAcceptedWeight: selectedFullInfoCity.maxAcceptedShippingWeight,
          maxAcceptedSize: selectedFullInfoCity.maxAcceptedSize,
        };
      }
    }

    return {
      dataForm,
      citiesArr,
      handlerCityTo,
      options,
      PHONE_MASK,
      INN_MASK,
      PHONE_PLACEHOLDER,
      limitInput,
      getNameOrganization,
      disableIdenticalCity: function (value) {
        if (value === dataForm.sender.cityFrom) {
          return true
        }

        return false
      },

      checkPhone: function () {
        if (dataForm.consignee.phoneConsignee === dataForm.sender.phoneSender) {
          dataForm.consignee.emailConsignee = dataForm.sender.emailSender 
          dataForm.consignee.firstNameConsignee = dataForm.sender.firstNameSender 
          dataForm.consignee.secondNameConsignee = dataForm.sender.secondNameSender 
          dataForm.consignee.surnameConsignee = dataForm.sender.surnameSender 
          dataForm.consignee.innConsignee = dataForm.sender.innSender 
          dataForm.consignee.name = dataForm.sender.name 
        }
      },
    };
  },
};
